module.exports = __webpack_public_path__ + "static/media/volum-off.76413d5f.svg";